import { ReviewProduct, ReviewSource, ReviewType, TextReview } from '../../types';

export const textReviews: TextReview[] = [
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car, ReviewProduct.All],
    reviewerName: 'Nani@yourhouse',
    source: ReviewSource.AppStore,
    shortText: 'Reliable Caring Responsive',
    fullText:
      'Recently I had my car stolen and with Lemonade I was able to get my car back in a few days because of the tracker. I felt valued more at Lemonade than at other insurance companies!',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car, ReviewProduct.All],
    reviewerName: 'snorrisaurus',
    source: ReviewSource.AppStore,
    shortText: 'Timely Seamless Reliable',
    fullText:
      'Like a miracle I got notice that Lemonade Car insurance was now available. I RAN. Signed up myself and added to my boyfriend to my policy and have not looked back since.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car, ReviewProduct.All],
    reviewerName: 'Lemontech',
    source: ReviewSource.AppStore,
    shortText: 'Affordable Convenient Simple',
    fullText: 'Car insurance has never been easier or cheaper.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car, ReviewProduct.All],
    reviewerName: 'Frankie Nichols',
    source: ReviewSource.GooglePlay,
    shortText: 'Effortless Affordable Streamlined',
    fullText: 'It was very easy to switch my car insurance over, and the premiums are a lot cheaper.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Rebel Russell',
    source: ReviewSource.GooglePlay,
    shortText: 'Effortless Comprehensive Competitive',
    fullText:
      "This was the easiest insurance search I've done, and I've been comparing rates for two days now, bc we have a new car. So wonderful, and the best rate of them ALL, Thank you Lemonade Insurance!",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'dmel1227',
    source: ReviewSource.X,
    shortText: 'Affordable Savings Rewarding',
    fullText: "Making the switch to @Lemonade_Inc Car was the best financial decision I've made. Nearly 40% savings",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'cph_capital',
    source: ReviewSource.X,
    shortText: 'Innovative Cutting-edge User-friendly',
    fullText:
      "this new car insurance blows me away. Tech innovation at it's best - smarter, cheaper, better user experience",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'nadavwiz',
    source: ReviewSource.X,
    shortText: 'Reliable Consistent Impeccable',
    fullText: 'Oh man @Lemonade_Inc just does everything right. All the time: https://lemonade.com/car',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life, ReviewProduct.All],
    reviewerName: 'peerlessmoney',
    source: ReviewSource.X,
    shortText: 'Easy Responsible Convenient',
    fullText:
      'After shopping around for a small life insurance policy, I decided to go with @Lemonade_Inc. Why? The sign-up process was easy.Now my mom can stop bugging me about purchasing a policy lol',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life, ReviewProduct.All],
    reviewerName: 'Steve_Symington',
    source: ReviewSource.X,
    shortText: 'Fun Cost-effective Seamless',
    fullText:
      'Just bought a new life insurance policy from @Lemonade_Inc. The process in the app was seamless (dare I say kinda fun!), & their quote was slightly more than half the cost of another I received from a competing insurer.Well done.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life, ReviewProduct.All],
    reviewerName: 'Justin',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Hassle-free Recommended Instant',
    fullText:
      ' I started down the path to get insurance several times but never pushed through because of the hassle. With Lemonade, I went from needing a policy to having a policy in five minutes. I recommend Lemonade for your insurance needs.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life, ReviewProduct.All],
    reviewerName: 'Jason',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Fair Comforting Priceless',
    fullText:
      'Lemonade has given me peace of mind. Making it so easy to obtain enough insurance, at a fair price, for my family to be taken care of if something happens to me. I sleep better at night now. Thanks Lemonade.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Matthew',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Trustworthy Smooth Comfortable',
    fullText:
      'Really easy getting a policy through Lemonade. Such a better alternative/experience than having to deal with the overly salesman culture of life insurance.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Carl',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Effortless Convenient Refreshing',
    fullText:
      'My 20-year policy from an old company had expired, and I dreaded having to go through the process again, which last time was very time-consuming and invasive. Lemonade made it so easy it was fantastic.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Andrew',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Upgrade Relaxed Comforting',
    fullText:
      "When I was expecting my next child I knew I needed to up my coverage. Hopefully I never experience the payout side of life insurance with Lemonade, but if it's anything like the sign up process, I know my family will be okay.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet, ReviewProduct.All],
    reviewerName: 'Allie',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Helpful Cost-effective Vital',
    fullText:
      "Everyone I've had contact with has been wonderful. I have save much more money on veterinary care than I spend on insurance. Get the pet insurance while they're still young and are likely to need something!",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet, ReviewProduct.All],
    reviewerName: 'Morgan',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Responsive Reassuring Satisfying',
    fullText:
      "People get back to you quickly, which helps ease the nerves. As someone who's been intimidated by claims, insurance, and all that stuff, I'm glad I found Lemonade. My dog is covered and I feel good.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet, ReviewProduct.All],
    reviewerName: 'Elizabeth',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Efficient Fast Reliable',
    fullText:
      'I filed a claim for a kennel cough illness visit, and it took maybe five minutes to file on my phone and the money was wired into my bank account that same day. I would (and have) recommended Lemonade to both friends and family.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet, ReviewProduct.All],
    reviewerName: 'Liz',
    source: ReviewSource.TrustPilot,
    shortText: 'Convenient Supportive Valuable',
    fullText:
      "It took two minutes to get my pet's preventative care claim approved. So grateful for this insurance! It helps keep them healthy while being affordable for me.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet],
    reviewerName: 'Jen LaBar',
    source: ReviewSource.TrustPilot,
    shortText: 'Life-saving Simple Quick',
    fullText:
      'I recently submitted a claim because my dog was bitten by a rattlesnake and needed emergency care. Lemonade made the process easy and fast. I submitted the info online, and they issued payment in days.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet],
    reviewerName: 'Kris Pepper',
    source: ReviewSource.TrustPilot,
    shortText: 'Vital Moral Worthwhile',
    fullText:
      'My Calico chewed and ate a silicone pan handle, creating a blockage. Thankfully, Lemonade came through, and after a small deductible, covered 90% of the $6,000 surgery! After this, I genuinely believe insuring your pets is the morally correct decision.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet],
    reviewerName: 'Colin M',
    source: ReviewSource.Bbb,
    shortText: 'Impactful Dependable Compassionate',
    fullText:
      'Without Lemonade, I would have certainly lost my cat to an autoimmune disease over a year ago. They continue to support us and are a huge reason she continues to live a happy life.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Pet],
    reviewerName: 'Donna H',
    source: ReviewSource.Bbb,
    shortText: 'Surprising Simple Familair',
    fullText:
      "Lemonade pet insurance has out-performed my expectations. I thought it was going to be a nightmare processing claims, but now I can say, it's easier than pie. Thank you for making the process as easy as texting a friend.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Benedict',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'impressive Straightforward Modern',
    fullText:
      'Too good to be true. Fair rate, simple sign up. Highly recommend to folks that want a simple and technology oriented way to do business. I was impressed of how easy it was to sign up. This is the future.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters, ReviewProduct.All],
    reviewerName: 'Bhavesh',
    source: ReviewSource.Bbb,
    shortText: 'Quick Professional Fair',
    fullText:
      'My ebike was stolen when I parked it for a few hours ... Lemonade was very quick and professional in determining the price of the ebike and paying me the full fair amount to offset the loss from theft. Thank you!',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters, ReviewProduct.All],
    reviewerName: 'Lucas',
    source: ReviewSource.Bbb,
    shortText: 'Supportive Efficient Top-Notch',
    fullText:
      'I had a very positive experience with the handling of my renters insurance claim after a terrible hail storm had broke windows and damaged several personal items in the house I am in. ... Highly recommend! A+++',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters, ReviewProduct.All],
    reviewerName: 'Marina',
    source: ReviewSource.Bbb,
    shortText: 'Friendly Empathetic Timely',
    fullText:
      'Very friendly and empathetic customer service. My adjuster was very polite and responded in a timely matter. The result were more than I expected. Will highly recommend this insurance to peers and friends.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters, ReviewProduct.All],
    reviewerName: 'Alex',
    source: ReviewSource.Bbb,
    shortText: 'Excellent Quick Fair',
    fullText:
      'My experience with Lemonade has been excellent . My claim was handled quickly and they were very fair to me. I recommend Lemonade to anyone who needs apartment rental coverage',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Jodi',
    source: ReviewSource.Bbb,
    shortText: 'Fast Innovative Supportive',
    fullText:
      'I had a pipe burst and water damage from the ice storm. I have never put in a claim before and had no idea if it would be approved. Lemonade approved it same day and money arrived two days later.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Gerald',
    source: ReviewSource.Bbb,
    shortText: 'Easy Affordable Empathetic',
    fullText: 'Easy and affordable renters insurance with incredible and personable customer relations.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home, ReviewProduct.All],
    reviewerName: 'Devansh',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Transparent Efficient Affordable',
    fullText:
      'I highly recommend Lemonade Home Insurance. Their excellent customer service, transparent policies, efficient claim handling and competitive pricing make them stand out in the insurance market.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home, ReviewProduct.All],
    reviewerName: 'Katiushka',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Exceptional Easy Empathetic',
    fullText:
      'We definitely recommend Lemonade for anyone looking for exceptional service and support. Thank you for making it easy and helping us get our house back into working order.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home, ReviewProduct.All],
    reviewerName: 'Usman',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Amazing Next-level Fast',
    fullText:
      'The AI model used to respond to claims is next level and I was simply amazed by how fast the whole claim was reviewed and processed. ... The whole process took 2 days for resolution.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home, ReviewProduct.All],
    reviewerName: 'Milena',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Speedy Responsive Delightful',
    fullText:
      'I submitted my claim on a Monday and I heard from someone by the afternoon!! They sent an adjuster the next day and approved everything in only two days!!',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'Brandi',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Quick Seamless Supportive',
    fullText:
      'During one of the most devastating times of my life - Lemonade stepped up and and provided quick and seamless assistance. They made everything so easy. ',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Katie',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Unique Compassionate Outstanding',
    fullText:
      "Lemonade is one of a kind. I never thought one could have such a positive experience with insurance (especially in the wake of a tragedy like a fire) but Lemonade's commitment to their customers shines",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Sarah',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Fun Modern Innovative',
    fullText:
      'They make it so easy to file a claim, and true to the marketing, they actually make insurance fun and modern ... The policies and coverage are easy to understand, and I love that they use AI to streamline things. ',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Zafer',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Easy Straightforward Valuable',
    fullText:
      "I have been with Lemonade for quite some time and this week I filed a claim for the first time. I can't believe how easy and straightforward the process was. Great value and great to have this peace of mind.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Natalia',
    source: ReviewSource.AppStore,
    shortText: 'Quick Responsive Easy',
    fullText:
      'Excellent customer support, easy to use, and very quick to answer questions. My bike wheel was stollen and the insurance worked quickly and efficiently',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Linda',
    source: ReviewSource.AppStore,
    shortText: 'Easy Delightful Bundles',
    fullText: 'Easy breezy, I have renters insurance, next is pet insurance, and car insurance',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Renters],
    reviewerName: 'Jill',
    source: ReviewSource.AppStore,
    shortText: 'Delightful Effortless Fast',
    fullText:
      "This was the easiest parts of getting into my new apartment. I had no idea how quick and effortless it would be i'm delighted",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Joshua',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Convenient Efficient Competitive',
    fullText:
      'Lemonade was easy to use, and gave a price for equal coverage that compared favorably with other companies that required a lot more paperwork. I would recommend Lemonade to others for Life Insurance.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Candace',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Accessible Intuitive Practical',
    fullText:
      'The application process with Lemonade could not have been easier. I was insured within 15 minutes tops. I put in my information, answered some basic health questions and went about my busy day.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'JJ',
    source: ReviewSource.TrustPilot,
    shortText: 'Prompt Commendable Reliable',
    fullText:
      'Excellent service, highly recommended!The real story here was how they turned around a collateral assignment (needed for my lender). They did this same day - huge kudos to the service team. Use this company for life insurance. ',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Michael Wilson ',
    source: ReviewSource.TrustPilot,
    shortText: 'Simply Straightfoward Reliable',
    fullText:
      "Pretty easy to set up a life insurance policy. If I die in the next 20 years I'll be sure to tell my wife to leave a follow up review with how easy it is to claim the money",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Darius',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Clear Positive Accessible',
    fullText:
      'Thank you Lemonade for affordable life insurance. You guys made the process simple and seamless. I will be recommending this to others. If anyone is interested in getting insurance, and sees this review just go ahead and do it.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Ken',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Clear Impressive Reliable',
    fullText:
      'Awesome rates and VERY EASY application, Took hardly no time to fill out, submitted it, and got results back quickly. It is a relief to have coverage for my family if I die. Thanks to Lemonade!!!!',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Life],
    reviewerName: 'Tielman',
    source: ReviewSource.ConsumerAffairs,
    shortText: 'Unbelievable Refreshing Breezy',
    fullText:
      "So simple I almost couldn't believe it. After going through the process of trying to find life insurance using a comparison tool and finding the process to be arduous, getting set up with Lemonade was a breeze.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Leonardo',
    source: ReviewSource.Internalreview,
    shortText: 'Convenient Accessible Comprehensive',
    fullText:
      'So far, I love how easy is to do everything and connect with it. I have the insurance for my dog and my car here.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Tamar',
    source: ReviewSource.TrustPilot,
    shortText: 'Effortless Efficient Self-sufficient',
    fullText:
      "It's super easy to submit claims through the app. Almost no need to speak to a customer rep- I've been with Lemonade for 3 years and spoke to reps maybe twice. Steps are easy to understand.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Daniel',
    source: ReviewSource.TrustPilot,
    shortText: 'User-friendly Quick Reliable',
    fullText:
      "Lemonade app is the best! It's easy to navigate to find policy info and the claim process is super fast and efficient. Highly recommended!",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Mike',
    source: ReviewSource.TrustPilot,
    shortText: 'Seamless Thorough Efficient',
    fullText:
      "Always smooth sailing with Lemonade. They make the claim process ease and ask all the necessary questions they need so it's not a long, painful, drawn out process.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Mary V',
    source: ReviewSource.Bbb,
    shortText: 'Simple Reliable Hassle-free',
    fullText: "Great insurance, super easy to use. I've never had any issues submitting claims.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Debra B',
    source: ReviewSource.Bbb,
    shortText: 'Fast Trustworthy Transparent',
    fullText:
      "You can't beat their speed for review and payment. I have not had to 'fight' about anything. I even bought stock because I love how they run their company",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Car],
    reviewerName: 'Glenn',
    source: ReviewSource.Internalreview,
    shortText: 'Supportive Responsive Consistent',
    fullText: 'Excellent customer service from start to finish.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'myfriend idriselba',
    source: ReviewSource.TrustPilot,
    shortText: 'Friendly Stress-free Reliable',
    fullText:
      'We had a pipe burst and had to find housing while they ripped up our floors. The agent was friendly and the process was stress free. We sold our apartment, but we still use Lemonade for renters insurance. ',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'Mr david christie',
    source: ReviewSource.TrustPilot,
    shortText: 'Seamless Magnificent Brilliant',
    fullText:
      ' Home insurance? Sign up, seamless. Add something later? Seamless, just done there and then. Magnificent, absolutely outstanding customer service. No praising words adequate. Brilliant not even close.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'LG18',
    source: ReviewSource.Clearsurance,
    shortText: 'Immediate Efficient Recommended',
    fullText:
      'When the big winter storm hit Texas in February, two pipes leaked inside the house. I immediately filed a claim over the phone. I have never dealt with such an efficient insurance company. Highly recommended!',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'sudarshan24',
    source: ReviewSource.Clearsurance,
    shortText: 'Easy Reliable Trustworthy',
    fullText:
      'My entire crawl space flooded due to a broken pipe. The Lemonade app made it super easy to start the claim. I am really happy I went with Lemonade for my home insurance. It is by far the best, I trust them completely.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'Julie_G',
    source: ReviewSource.Clearsurance,
    shortText: 'Kind Helpful Supportive',
    fullText:
      'I recently had significant water damage to my kitchen ceiling from my bathroom and had to reach out to Lemonade for support. My agent was kind and helped me through the process. ',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'mkern',
    source: ReviewSource.Clearsurance,
    shortText: 'Tech-savvy Fast Easy',
    fullText:
      "Awesome AI, great customer service... And it's extremely fast and easy from the online website, to the app to completion.",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'RyDru2',
    source: ReviewSource.Clearsurance,
    shortText: 'Cutting-edge Revolutionary Lovable',
    fullText:
      "I'm one of the youngest Home in my neighborhood and everyone around me has archaic insurance firms that don't help out when they need to. If I could fly a Lemonade Flag in my yard I would. ",
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'Lorena',
    source: ReviewSource.Internalreview,
    shortText: 'Friendly Efficient Communicative',
    fullText:
      'You guys are rad, and always kind, and on top of stuff, easy to communicate with, and I appreciate yall.',
  },
  {
    type: ReviewType.Text,
    product: [ReviewProduct.Home],
    reviewerName: 'Amanda',
    source: ReviewSource.Internalreview,
    shortText: 'Affordable Comprehensive Exceptional',
    fullText:
      'Rates are fantastic, especially in comparison to the same coverage in this area from traditional providers. Customer service has been phenomenal so far.',
  },
];
